



























































































































































































































































































































import { Component, Ref } from 'vue-property-decorator';
import { CheckIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import UserCard from '@/components/common/UserCard.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import Shepherd from 'shepherd.js';
import confetti from 'canvas-confetti';
import { IAchievementMap, UserStatus } from 'admiral-core';
import { AuthAction } from '@/store/AuthModule';

export type OnboardingAchievements = Pick<
  IAchievementMap,
  'login1' | 'onboardingVideo' | 'tour.createPolicy'
> & { overview?: Date };

@Component({
  components: {
    FormSubmit,
    UserCard,
    UserStatusBadge,
    Avatar,
    XIcon,
    CheckIcon,
  },
})
export default class TourModal extends mixins(BaseMixin) {
  selectedStep: keyof OnboardingAchievements = 'overview';
  lastCompletedStep: keyof OnboardingAchievements | null = null;
  steps: OnboardingAchievements = {};

  videoPlayed = false;

  isLoading = false;
  isDone = false;

  @Ref('video') video!: HTMLVideoElement;
  @Ref('tour') tourModal!: BModal;

  shepherdSteps: Record<string, any> = {
    step1: {
      id: 'step1',
      title: 'Schritt 1 von 5',
      attachTo: { element: '#menu-button-policies', on: 'right-start' },
      text: 'Klicke hier auf <b>Anbahnungen</b> um zu den Anbahnungen zu gelangen.',
      modalOverlayOpeningRadius: 5,
      classes: 'ml-2',
    },
    step2: {
      id: 'step2',
      title: 'Schritt 2 von 5',
      attachTo: {
        element: '#button-create-policy',
        on: 'left-start',
      },
      text: 'Klicke auf den <b>Anbahnung anlegen</b>-Button um das Formular-Fenster zu öffnen.',
      modalOverlayOpeningRadius: 5,
      classes: 'mr-2',
    },
    step3: {
      id: 'step3',
      title: 'Schritt 3 von 5',
      attachTo: {
        element: '#container-left-create-policy',
        on: 'right',
      },
      text: `<b>Erstelle deine erste Anbahnung</b>
            <br><br>
            Befülle die alle nicht-optionalen Felder und es geht zum nächsten Schritt.
            <br><br>
            Beispiel:
            <br><br>
            <ul>
            <li>Kunde: <i>Max Mustermann</i></li>
            <li>Produkt: <i>Kraft</i></li>
            <li>Bewertung: <i>250</i></li>
            <li>Stückzahl: <i>1</i></li>
            <li>Status: <i>OFFEN</i></li>
            <li>Abschlusswahrscheinlichkeit: <i>70%</i></li>
            </ul>`,
      modalOverlayOpeningRadius: 5,
      classes: 'ml-2',
    },
    step3b: {
      text: `<b>Erstelle deine erste Anbahnung</b>
            <br><br>
            Befülle die alle nicht-optionalen Felder und es geht zum nächsten Schritt.
            <br><br>
            Beispiel:
            <br><br>
            <ul>
            <li>Kunde: <i>Max Mustermann</i></li>
            <li>Produkt: <i>Kraft</i></li>
            <li>Bewertung: <i>250</i></li>
            <li>Stückzahl: <i>1</i></li>
            <li>Status: <i>OFFEN</i></li>
            <li>Abschlusswahrscheinlichkeit: <i>70%</i></li>
            </ul>
            <br>
            <div class="badge badge-light-success"> Alle benötigten Felder sind ausgefüllt </div>
              `,
      buttons: [
        {
          // @ts-ignore
          action: () => {
            return this.tour.next();
          },
          text: 'Zum nächsten Schritt',
        },
      ],
    },
    step4: {
      id: 'step4',
      title: 'Schritt 4 von 5',

      text: 'Du hast alle nötigen Daten eingegeben. Klicke nur noch auf <b>Speichern + Schließen</b> klicken um zur Übersicht zu gelangen.',
      modalOverlayOpeningRadius: 5,
      classes: 'mb-2',
      attachTo: {
        element: '#button-submit-policy',
        on: 'top',
      },
      buttons: [
        {
          // @ts-ignore
          action: () => {
            return this.tour.back();
          },
          secondary: true,
          text: 'Ein Schritt zurück',
        },
      ],
    },
    step5: {
      id: 'step5',
      title: 'Schritt 5 von 5',

      text: 'Gratulation. Du hast deine erste Anbahnung angelegt.',
      modalOverlayOpeningRadius: 5,
      classes: 'mb-2',
      attachTo: {
        element:
          '#policies-overview > tbody > tr:nth-child(0), #policies-overview > tbody > tr:nth-child(1)',
        on: 'top',
      },
      buttons: [
        {
          // @ts-ignore
          action: () => {
            return this.tour.complete();
          },
          text: 'Tour abschließen',
        },
      ],
    },
  };

  mounted() {
    this.steps = (this.user.achievementMap as OnboardingAchievements) || {};

    if (this.user.status === UserStatus.FIRST_LOGIN) {
      this.selectedStep = 'login1';
      this.completeStep();
    }
  }

  cancel() {
    this.tourModal.hide();
  }

  async reloadUsers() {
    await this.fetchUsers();
  }

  isCompleted(step: keyof OnboardingAchievements) {
    return typeof this.steps[step] !== 'undefined';
  }

  async completeStep() {
    this.steps[this.selectedStep] = new Date();
    this.lastCompletedStep = this.selectedStep;
    try {
      await this.$store.dispatch(`AuthModule/${AuthAction.UpdateAchievements}`, {
        item: this.selectedStep,
      });
      if (this.isEverythingCompleted()) {
        setTimeout(() => {
          confetti({
            zIndex: 10000,
          });
        }, 250);
      }

      setTimeout(() => {
        this.lastCompletedStep = null;
      }, 2500);
      this.selectedStep = 'overview';
    } catch (e) {
      console.log(e);
    }
  }
  cancelStep() {
    if (this.selectedStep === 'onboardingVideo') {
      this.video.pause();
    }
    this.selectedStep = 'overview';
  }
  cancelTour() {
    //
  }
  startVideoStep() {
    this.selectedStep = 'onboardingVideo';
    this.$nextTick(() => {
      this.video.addEventListener('ended', () => {
        this.videoPlayed = true;
      });
      this.video.play();
    });
  }

  async startPoliciesTour() {
    this.cancel();
    this.selectedStep = 'tour.createPolicy';
    const tour: Shepherd.Tour = this.$shepherd({
      useModalOverlay: true,
      exitOnEsc: true,
      confirmCancel: true,
      confirmCancelMessage: 'Möchtest Du die Tour wirklich beenden?',
      scrollTo: true,
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        scrollTo: { behavior: 'smooth', block: 'center' },
      },
    });
    await this.$store.dispatch('setPoliciesTour', tour);
    this.$root.$once('bv::modal::hide', async (bvEvent: BvModalEvent, modalId: string) => {
      // @ts-ignore

      if (this.tour && this.tour.getCurrentStep()?.id !== 'step4') {
        // @ts-ignore
        this.tour.options.confirmCancel = false;
        this.tour.cancel();
      }
    });
    // highlight "Verträge" icon in main menu
    this.tour.addStep(this.shepherdSteps['step1']);

    if (this.$route.name === 'policies.all') {
      this.$root.$once('click-menu-button-policies', () => {
        this.tour.addStep(this.shepherdSteps['step2']);
        this.tour.next();
      });
    } else {
      this.$root.$once('route-changed', (name: string) => {
        if (name === 'policies.all') {
          setTimeout(() => {
            this.tour.addStep(this.shepherdSteps['step2']);
            this.tour.next();
          }, 350);
        }
      });
    }

    this.$root.$once('click-button-create-policy', () => {
      setTimeout(() => {
        this.tour.addStep(this.shepherdSteps['step3']);
        this.tour.next();
      }, 300);
    });

    this.$root.$once('complete-required-create-policy', () => {
      const step3 = this.tour.getById('step3');
      if (step3) {
        this.$nextTick(() => {
          setTimeout(() => {
            step3.updateStepOptions(this.shepherdSteps['step3b']);
            this.tour.addStep(this.shepherdSteps['step4']);
          }, 300);
        });
      }
    });

    this.$root.$once('on-submit-create-policy', () => {
      this.$nextTick(() => {
        this.tour.addStep(this.shepherdSteps['step5']);

        setTimeout(() => {
          this.tour.next();
        }, 300);
      });
    });

    this.$nextTick(async () => {
      this.tour.start();
    });

    this.tour.on('complete', async () => {
      (this.$refs['tour'] as BModal).show();
      this.completeStep();
      this.$root.$off('route-changed');
      this.$root.$off('click-menu-button-policies');
      this.$root.$off('complete-required-create-policy');
      this.$root.$off('on-submit-create-policy');
      await this.$store.dispatch('cancelTour');
    });
    this.tour.on('cancel', async () => {
      (this.$refs['tour'] as BModal).show();
      this.cancelStep();
      this.$root.$off('route-changed');
      this.$root.$off('click-menu-button-policies');
      this.$root.$off('complete-required-create-policy');
      this.$root.$off('on-submit-create-policy');
      await this.$store.dispatch('cancelTour');
    });
  }
  get tour(): Shepherd.Tour {
    return this.$store.getters.policiesTour;
  }

  get isAwardFeatureActive() {
    return false;
  }
  isEverythingCompleted() {
    return (
      !!this.steps?.['login1'] &&
      !!this.steps?.['onboardingVideo'] &&
      !!this.steps?.['tour.createPolicy']
    );
  }
}
